import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleGeminiIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 25,
			height: 25,
			rx: 5,
			fill: "#FAFAFA"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_11317_17969)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.603 11.6748C17.4262 11.1739 16.3563 10.4523 15.4509 9.54908C14.19 8.28565 13.2904 6.7076 12.8456 4.97891C12.8261 4.90213 12.7816 4.83405 12.719 4.78542C12.6565 4.73679 12.5795 4.71039 12.5003 4.71039C12.4211 4.71039 12.3441 4.73679 12.2816 4.78542C12.2191 4.83405 12.1745 4.90213 12.155 4.97891C11.7093 6.70738 10.8096 8.28524 9.54903 9.54908C8.64352 10.4522 7.5736 11.1737 6.39695 11.6748C5.93653 11.8731 5.46337 12.0325 4.97887 12.155C4.90162 12.174 4.83296 12.2184 4.78388 12.281C4.7348 12.3436 4.70813 12.4208 4.70813 12.5004C4.70813 12.5799 4.7348 12.6571 4.78388 12.7197C4.83296 12.7823 4.90162 12.8267 4.97887 12.8457C5.46337 12.9675 5.93512 13.1269 6.39695 13.3252C7.57367 13.8261 8.64361 14.5477 9.54903 15.4509C10.8103 16.7145 11.7101 18.2928 12.155 20.0218C12.174 20.099 12.2183 20.1677 12.2809 20.2168C12.3435 20.2659 12.4208 20.2925 12.5003 20.2925C12.5799 20.2925 12.6571 20.2659 12.7197 20.2168C12.7823 20.1677 12.8266 20.099 12.8456 20.0218C12.9675 19.5366 13.1268 19.0648 13.3252 18.603C13.8261 17.4263 14.5476 16.3563 15.4509 15.4509C16.7145 14.1899 18.2928 13.2904 20.0217 12.8457C20.0985 12.8261 20.1666 12.7816 20.2152 12.7191C20.2639 12.6565 20.2903 12.5796 20.2903 12.5004C20.2903 12.4211 20.2639 12.3442 20.2152 12.2816C20.1666 12.2191 20.0985 12.1746 20.0217 12.155C19.5368 12.033 19.0623 11.8724 18.603 11.6748Z",
				fill: "#252B37"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_11317_17969",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 17,
				height: 17,
				fill: "white",
				transform: "translate(4 4)"
			})
		}) })
	]
});
export default SvgGoogleGeminiIcon;
